import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-user-bulk-delete',
		path: '/admin/bulk_delete_users',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin-user-bulkDelete" */ './index'), {
			exportName: 'BulkDeleteUsers',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['supportAdmin'],
		},
		frame: true,
	},
];
